export default {
  mounted () {
    this.$loading(false)
  }
}
